















import { Prop, Component, Vue } from "vue-property-decorator";

@Component({})
export default class VIconPrint extends Vue {
  @Prop({ required: true }) load!: boolean;
}
